<s2a-wc-dialog-header [showClose]="true" [heading]="data.title" (closed)="onClose()"></s2a-wc-dialog-header>
<div mat-dialog-content class="dialog-body">
  <p>
    <span>Edge Device: </span>
    <span>{{ data.metaData.lineName }}</span>
  </p>
  <p>
    <span>{{ data.currentState.status }}: </span>
    <span>{{ timestamp }}</span>
  </p>
  <p>
    <span>{{ 'components.external_system.duration' | translate }}: </span>
    <span>{{ data.currentState.timestamp | formatEpoch: currentTimeStamp }}</span>
  </p>
  <span>{{ data.description }}</span>
</div>
<s2a-wc-dialog-footer
  saveText="{{ 'components.external_system.contact_support' | translate }}"
  cancelText="{{ 'components.external_system.close' | translate }}"
  (cancel)="onClose()"
  (save)="onContactSupport()"
></s2a-wc-dialog-footer>
